import constants from 'constants/index'

// Cores e ícones de status do board: contestação, projeto coberto por Revisão ou base.
const getStatusBoardPalette = ({ isUnderContestation, isCoveredByReview }) => {
  const {
    AUDIT_CHOOSE_STATUS_BOARD_COLOR,
    AUDIT_CHOOSE_STATUS_BOARD_ICON,
    CHOOSE_STATUS_BOARD_COLOR,
    CHOOSE_STATUS_BOARD_ICON,
    REVIEW_CHOOSE_STATUS_BOARD_COLOR,
    REVIEW_CHOOSE_STATUS_BOARD_ICON,
  } = constants.governanceProjectActivity

  if (isUnderContestation) {
    return {
      statusColors: AUDIT_CHOOSE_STATUS_BOARD_COLOR,
      statusIcons: AUDIT_CHOOSE_STATUS_BOARD_ICON,
    }
  }

  if (isCoveredByReview) {
    return {
      statusColors: REVIEW_CHOOSE_STATUS_BOARD_COLOR,
      statusIcons: REVIEW_CHOOSE_STATUS_BOARD_ICON,
    }
  }

  return {
    statusColors: CHOOSE_STATUS_BOARD_COLOR,
    statusIcons: CHOOSE_STATUS_BOARD_ICON,
  }
}

export default getStatusBoardPalette
